import React from 'react'
import OurSection from '../components/our-section'
import Header from '../components/header'
import Hero from '../components/Hero'
import HomeAboutSection from '../components/home-about-section'
import Learning from '../components/learning'
import OurServices from '../components/ourservices'
import Discover from '../components/discover'
import Newletter from '../components/newletter'
import Educatiion from '../components/Education'
import VideoPlayer from '../components/educational-video'
import TravelVideoPlayer from '../components/travel-video'

interface Props {
    
}

const HomePage = (props: Props) => {
    return (
        <div>
           <Header/>
           <Hero/>
           <OurServices/>
           <Learning/>
           <TravelVideoPlayer/>
           <Educatiion/>
           <VideoPlayer/>
           <HomeAboutSection/>
           <OurSection/>
           <Discover/>
           {/* <WhyChooseUs/> */}
           <Newletter/>
        </div>
    )
}

export default HomePage
